import { IOrderService, OrderService } from "@/services/order-service";
import { connect } from "react-redux";
import OrderPlanInitial from "./index";

import { Dispatch } from "@reduxjs/toolkit";
import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapDispatchToProps = (dispatch: Dispatch) => {
  const orderService: IOrderService = new OrderService();
  return {
    // getCategorization: (
    //   locationTrees: ITreeInfo[],
    //   categoryTrees: ITreeInfo[],
    //   locationList: ICategorizationInfo[]
    // ) => {
    //   dispatch(updateLocationsAndCategory({locationTrees, categoryTrees, locationList}));
    // },
    // updateOutlookInfo: (outlookInfo: OutLookInfo) => {
    //   dispatch(updateOutlookInfo(outlookInfo));
    // },
    // updateOrganizer: (org: Organizer) => {
    //   dispatch(updateOrganizer(org));
    // },
    // updateTimeOfOutlook: (time: DateTimePeriodDto) => {
    //   dispatch(updateTimeOfOutlook(time));
    // },
    // updateSettings: (settingInfo: ISettingStore) => {
    //   dispatch(updateSettings(settingInfo));
    // },
    // updateOrgInfo: (orgInfo: OrganizationInfo) => {
    //   dispatch(updateOrgInfo(orgInfo));
    // },
    // updateAllResourcesSelectedFromParent: (resources: ResourceInfo[]) => {
    //   dispatch(updateAllResourcesDataInSelectedChangeRsOutlook(resources))
    // },
    onGetDataSession: (sessionId: string): Promise<HttpResponse<any>> => {
      return orderService.fetchSessionData(sessionId).then((resp) => {
        if (resp?.data?.Token) {
          window.axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + resp.data.Token;
        }
        return resp;
      });
    },
  };
};

export default connect(null, mapDispatchToProps)(OrderPlanInitial);
